export function SocialProof() {
  const STATS = [
    { value: '+15.000', label: 'mapas gerados' },
    { value: '4.9 ★',  label: 'avaliação média' },
    { value: '20+',    label: 'sistemas esotéricos' },
    { value: '97%',    label: 'recomendam a amigos' },
  ];

  return (
    <section style={{
      padding: '2.5rem 2rem',
      background: '#0F0620',
      borderTop: '1px solid rgba(212,175,55,0.15)',
      borderBottom: '1px solid rgba(212,175,55,0.15)',
    }}>
      <div
        style={{
          maxWidth: '1000px', margin: '0 auto',
          display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem', textAlign: 'center',
        }}
        className="social-proof-grid"
      >
        {STATS.map(({ value, label }) => (
          <div key={label}>
            <p style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(1.5rem, 4vw, 2.25rem)',
              fontWeight: 400, color: '#D4AF37',
              margin: '0 0 0.25rem', lineHeight: 1,
            }}>{value}</p>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: 'var(--text-13)',
              color: 'rgba(200,220,235,0.65)', margin: 0,
            }}>{label}</p>
          </div>
        ))}
      </div>
      <style>{`
        @media (max-width: 599px) {
          .social-proof-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
    </section>
  );
}
